module.exports = __webpack_public_path__ + "static/img/01.c492c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/01.png
// module id = DiUQ
// module chunks = 0